import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { SearchService } from '../../api/services/search.service';

export function userExistsValidator(
	search: SearchService,
	opts: { originalEmail?: string; excludeObjectId?: string } = {},
): AsyncValidatorFn {
	let timeoutId: number;
	const original = (opts.originalEmail ?? '').trim().toLowerCase();

	return (control: AbstractControl) => {
		const raw = String(control.value ?? '')
			.trim()
			.toLowerCase();

		// Return null immediately for empty values
		if (!control.value || control.value.trim() === '') {
			return Promise.resolve(null);
		}

		// Return null if the email hasn't been changed
		if (raw === original) {
			return Promise.resolve(null);
		}

		// Clear any existing timeout
		if (timeoutId) {
			clearTimeout(timeoutId);
		}

		// Return a promise that resolves after the debounce delay
		return new Promise((resolve) => {
			timeoutId = window.setTimeout(() => {
				search
					.search({
						searchClientEnvironments: false,
						searchClients: false,
						searchUsers: true,
						searchInstitutions: false,
						searchInstitutionBranches: false,
						searchInstitutionPerson: false,
						searchSponsors: false,
						searchIso: false,
						searchTerm: control.value,
					})
					.then((res) => {
						if (res.entities.length > 0) {
							// Convert the response to an item array
							const items = (res?.entities ?? []) as {
								item: { objectId?: string; id?: number; businessEmail?: string };
								personType?: number;
							}[];

							// Check if this email is already used by a different user, exclude current user via excludeObjectId
							const exists = items.some((i) => {
								const email = String(i.item.businessEmail ?? '')
									.trim()
									.toLowerCase();
								const objectId = String(i.item.objectId ?? '');

								return email === raw && (!opts.excludeObjectId || objectId !== opts.excludeObjectId);
							});

							resolve(exists ? { userExists: true } : null);
						} else {
							resolve(null);
						}
					})
					.catch(() => resolve(null));
			}, 200);
		});
	};
}
